import Highcharts from 'highcharts/highstock'
import drilldown from 'highcharts/modules/drilldown'
import exporting from 'highcharts/modules/exporting'
import exportData from 'highcharts/modules/export-data'
import offlineExporting from 'highcharts/modules/offline-exporting'
import annotationsAdvanced from 'highcharts/modules/annotations-advanced'
import priceIndicator from 'highcharts/modules/price-indicator'
import fullScreen from 'highcharts/modules/full-screen'
import stockTools from 'highcharts/modules/stock-tools'
import dragPane from 'highcharts/modules/drag-panes'
import treemap from 'highcharts/modules/treemap'
import heatmap from 'highcharts/modules/heatmap'
import more from 'highcharts/highcharts-more'
import boost from 'highcharts/modules/boost'
import map from 'highcharts/modules/map'

drilldown(Highcharts)
exporting(Highcharts)
exportData(Highcharts)
offlineExporting(Highcharts)
annotationsAdvanced(Highcharts)
priceIndicator(Highcharts)
fullScreen(Highcharts)
stockTools(Highcharts)
dragPane(Highcharts)
treemap(Highcharts)
heatmap(Highcharts)
more(Highcharts)
boost(Highcharts)
map(Highcharts)

if (process.env.NODE_ENV === 'test') {
  Highcharts.useSerialIds(true)
  Highcharts.setOptions({
    chart: {
      animation: false,
    },
    plotOptions: {
      series: {
        animation: false,
      },
    },
  })
}

const mountLang = (language = 'pt', magnitudeType = 'currency') => {
  const lang = {} as any
  if (magnitudeType === 'currency') {
    lang.numericSymbols = ['k', 'mi', 'bi', 'tri', 'qua', ' qui']
  }
  if (magnitudeType === 'physical') {
    lang.numericSymbols = ['k', 'M', 'G', 'T', 'P', 'E']
  }
  if (language === 'pt') {
    lang.contextButtonTitle = 'Menu de contexto do gráfico'
    lang.decimalPoint = ','
    lang.downloadCSV = 'Baixar CSV'
    lang.downloadJPEG = 'Baixar imagem JPEG'
    lang.downloadPDF = 'Baixar documento PDF'
    lang.downloadPNG = 'Baixar imagem PNG'
    lang.downloadSVG = 'Baixar imagem vetorizada SVG'
    lang.downloadXLS = 'Baixar XLS'
    lang.downloadXLSX = 'Baixar XLSX'
    lang.drillUpText = '◁ Retornar para {series.name}'
    lang.exitFullscreen = 'Sair ta tela cheia'
    lang.loading = 'Carregando...'
    lang.months = [
      'Janeiro',
      'Fevereiro',
      'Março',
      'Abril',
      'Maio',
      'Junho',
      'Julho',
      'Agosto',
      'Setembro',
      'Outubro',
      'Novembro',
      'Dezembro',
    ]
    lang.noData = 'Não há dados para exibição'
    lang.printChart = 'Imprimir gráfico'
    lang.rangeSelectorFrom = ''
    lang.rangeSelectorTo = '-'
    lang.rangeSelectorZoom = ''
    lang.resetZoom = 'Redefinir zoom'
    lang.resetZoomTitle = 'Redefinir nível de zoom 1:1'
    lang.shortMonths = [
      'Jan',
      'Fev',
      'Mar',
      'Abr',
      'Mai',
      'Jun',
      'Jul',
      'Ago',
      'Set',
      'Out',
      'Nov',
      'Dez',
    ]
    lang.thousandsSep = '.'
    lang.weekdays = [
      'Domingo',
      'Segunda',
      'Terça',
      'Quarta',
      'Quinta',
      'Sexta',
      'Sábado',
    ]
    lang.viewData = 'Exibir tabela de dados'
    lang.viewFullscreen = 'Ver em tela cheia'
  }
  return { lang: lang }
}

Highcharts.setOptions({
  ...mountLang('pt', 'currency'),
  exporting: {
    fallbackToExportServer: false,
  },
  chart: {
    backgroundColor: 'white',
    style: {
      fontFamily: '"Work Sans", sans-serif',
      fontSize: '15px',
    },
  },
  credits: { style: { fontSize: '13px' } },
  legend: {
    itemDistance: 10,
    itemStyle: { fontSize: '14px' },
  },
  tooltip: { style: { fontSize: '15px' } },
  xAxis: { labels: { style: { fontSize: '15px' } } },
  yAxis: { labels: { style: { fontSize: '15px' } } },
})

Highcharts.dateFormats = {
  q: (timestamp) =>
    Math.floor(new Date(timestamp).getUTCMonth() / 3 + 1).toString(),
  monthNumber: (timestamp) => new Date(timestamp).getMonth().toString(),
  nextYear: (timestamp) =>
    (new Date(timestamp).getUTCFullYear() + 1).toString(),
}

export default Highcharts
